
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoUPTkmt6PYNhkHNyWzQ59PqD0ZC0r64xXMPX4PQ7pMeEMeta } from "/var/www/2025-07-03_16_54/pages/edo.vue?macro=true";
import { default as helpMc8NieFno0XfZmyPcgk2o9Q09pPEqhfaPpHFmn36k90Meta } from "/var/www/2025-07-03_16_54/pages/help.vue?macro=true";
import { default as cargo_45HVDngsZKc_45c25QDeYIHlgnAUakhVTryxxgWS_KNMXEMeta } from "/var/www/2025-07-03_16_54/pages/cargo.vue?macro=true";
import { default as indexdCZLYLcaRxu3P3LVUzEtU9F7LYYDtiz3lu7Tg93FqLQMeta } from "/var/www/2025-07-03_16_54/pages/index.vue?macro=true";
import { default as _91slug_93BdZjPfihbQnuz3vYIOtAwp7dICxmOzxoaaRnMjrj_v4Meta } from "/var/www/2025-07-03_16_54/pages/[slug].vue?macro=true";
import { default as cookieec7r8s_45RBkmA86kvV_jGYvXesS2W_qJFuNoJ_eMHRUEMeta } from "/var/www/2025-07-03_16_54/pages/cookie.vue?macro=true";
import { default as belarusGqPZoUiqkht8_45Eyt722jr8K0z7UXDQ86zuVeA_45fCHKAMeta } from "/var/www/2025-07-03_16_54/pages/belarus.vue?macro=true";
import { default as bonusespLLNrfW12ccIHlVFQfYFFj8ZBJvsrlHFC1xljzMzhAMMeta } from "/var/www/2025-07-03_16_54/pages/bonuses.vue?macro=true";
import { default as apih8GcxOuN83TD69iovkretZXF_T77EaQtzueuYoMB56IMeta } from "/var/www/2025-07-03_16_54/pages/dev/api.vue?macro=true";
import { default as cmsDAKaexR_68cAASDPJxk_5PuF4Bp_45elnQKwpdaSryfFYMeta } from "/var/www/2025-07-03_16_54/pages/dev/cms.vue?macro=true";
import { default as konkurszXbIcJ6_45F_45uyaTM94_2tRokVh0n0HP6aHGMhFfSjDqcMeta } from "/var/www/2025-07-03_16_54/pages/konkurs.vue?macro=true";
import { default as successYDyOyL9FG432UuO6AGPVhXy8_HxzAzZ41ccNV9_DZQMMeta } from "/var/www/2025-07-03_16_54/pages/success.vue?macro=true";
import { default as tariffsEaiIw1SCgRbDSlOL5sTQ5WKTIdkKheKkeeVgDlr3pQEMeta } from "/var/www/2025-07-03_16_54/pages/tariffs.vue?macro=true";
import { default as vacancyNRY5vFnqxlqjIkQFMDutXQMDJL4_MoVBs7q5Om4Ed3MMeta } from "/var/www/2025-07-03_16_54/pages/vacancy.vue?macro=true";
import { default as contacts8_45TzRToe6U7yRusvNYYvat1nXQIrQCSAtZpCNL_Ss_45MMeta } from "/var/www/2025-07-03_16_54/pages/contacts.vue?macro=true";
import { default as giveaway_45076sQcxV4zKoJVTYCYx9lzqZ9dRTksvIIJgRBi21OMMeta } from "/var/www/2025-07-03_16_54/pages/giveaway.vue?macro=true";
import { default as guide_45lkzr6apuA9g8GR6VvbJ6af6WSuPxKsWXO8kq9ghCnhG2kMeta } from "/var/www/2025-07-03_16_54/pages/guide-lk.vue?macro=true";
import { default as servicesno67nGmneSrOKf8KOLepXw3ZV5fbGBFmHbA94Cmpt7QMeta } from "/var/www/2025-07-03_16_54/pages/services.vue?macro=true";
import { default as telegramaBzQsR1XBSE07WeBKcXrN87GLY8oyDR6beLFiwf5na8Meta } from "/var/www/2025-07-03_16_54/pages/telegram.vue?macro=true";
import { default as documents62aOh0HmwMUkFwj8ARK7mE09m0J2_cXhaLiWFZEdVEwMeta } from "/var/www/2025-07-03_16_54/pages/documents.vue?macro=true";
import { default as franchisekMg7R7dODhOGYOHTNXaHz4rsnsmrsyZDUkHfHQsuCeYMeta } from "/var/www/2025-07-03_16_54/pages/franchise.vue?macro=true";
import { default as insuranceDy9GG_45wl9pYgwfuyQ4IwhQQ9LwZ2vwbjF8KvN_xayAIMeta } from "/var/www/2025-07-03_16_54/pages/insurance.vue?macro=true";
import { default as kirghiziaCSjIKaMuZZDaGwwSdzAIPlfSLUUpS3I0PLAgvC18F1MMeta } from "/var/www/2025-07-03_16_54/pages/kirghizia.vue?macro=true";
import { default as mapSchemex0AFP_tZ8gg3kNGMU_452E_F7M00GuISNYn_AlGvlP0_QMeta } from "/var/www/2025-07-03_16_54/pages/mapScheme.vue?macro=true";
import { default as _91id_93wJ69KPLqgjeWmma0jp5VKUNzosmyPwt9cIw0qimojs8Meta } from "/var/www/2025-07-03_16_54/pages/news/[id].vue?macro=true";
import { default as return_45sdCgN8qYieU_6i7llTImphTE5ozlpz7oV8x6iiomqfS0IMeta } from "/var/www/2025-07-03_16_54/pages/return-sd.vue?macro=true";
import { default as smsClient6KIPPhhGsydiqtG02fOmgtrixy6h0c9fsvbl_456bUsckMeta } from "/var/www/2025-07-03_16_54/pages/smsClient.vue?macro=true";
import { default as terminalsLEIwfxuXgcA1DJ_6sqZ_nTo5F4XOWinImUqi6T56i9EMeta } from "/var/www/2025-07-03_16_54/pages/terminals.vue?macro=true";
import { default as iframeVGAy83XrSB9GJkV9Au3O7v2MOYhzh4IlOoUTRngD4Y8Meta } from "/var/www/2025-07-03_16_54/pages/dev/iframe.vue?macro=true";
import { default as directionsQa2bLxPQvwK3OEFDfuStwLFnvVttaGtIit4O5QhkZOUMeta } from "/var/www/2025-07-03_16_54/pages/directions.vue?macro=true";
import { default as kazakhstanTfgWGa258p6FQn4LLAec3uO3xjt8u_j70UoUS0191G4Meta } from "/var/www/2025-07-03_16_54/pages/kazakhstan.vue?macro=true";
import { default as indexyRXAtARUjB4WeZG_45E9Qb8e7t6oD1Y8F1cJRDRVfv3LgMeta } from "/var/www/2025-07-03_16_54/pages/news/index.vue?macro=true";
import { default as svgtO0_g_4511jy15SDaSks4tHW7YIGleLZM7YLrpoFppaBoMeta } from "/var/www/2025-07-03_16_54/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failCZZnZsdEI595Lay9e6otz2XnA_EW9O_45kQWFulKsQo0EMeta } from "/var/www/2025-07-03_16_54/pages/vzpay-fail.vue?macro=true";
import { default as constructor2f5Ro8_uyGS6Q5YLpPCOvQTtXBEfCuhCFc7873vlMfIMeta } from "/var/www/2025-07-03_16_54/pages/constructor.vue?macro=true";
import { default as indexhTRWGxZZhSilGY9b89pstWTF6bKUOlBnetPEz_45tb8uIMeta } from "/var/www/2025-07-03_16_54/pages/gifts/index.vue?macro=true";
import { default as information97lfrBnLZPDB4L9m0j_45Pg42WWytSNSdwZj1W8skO_U4Meta } from "/var/www/2025-07-03_16_54/pages/information.vue?macro=true";
import { default as lightBUsZZN3oqCo0nEISVz_45R701ZwYfc8Y_maMRRCsjFzeoMeta } from "/var/www/2025-07-03_16_54/pages/order/light.vue?macro=true";
import { default as claim_45filingUrSRJVxlEpKGDSVoTn2kEo9rARQ_45yxal1X_CjoFdCIAMeta } from "/var/www/2025-07-03_16_54/pages/claim-filing.vue?macro=true";
import { default as _91type_93TzeQDBZzehHepONsBGRH78Qfy7N2DXZVDBD13gBbX1EMeta } from "/var/www/2025-07-03_16_54/pages/gifts/[type].vue?macro=true";
import { default as marketplacesnNxpdESDEq_45WJajY3uXGESNBPLW7i6ko8oVvth7E4oIMeta } from "/var/www/2025-07-03_16_54/pages/marketplaces.vue?macro=true";
import { default as networkshopsXicepiQcHLy3yMnCIRqAmBlnZ_450Z4nYC2fUx8mpCO5AMeta } from "/var/www/2025-07-03_16_54/pages/networkshops.vue?macro=true";
import { default as online_45storevvWlqCmtzHjf3mC8NF0MUTh1aTlumgOQ8RSnnSZ92fUMeta } from "/var/www/2025-07-03_16_54/pages/online-store.vue?macro=true";
import { default as manageruIbl_znn77xVy1F0F7Ea_y5N6kzQgTxi35PggMxCUEMeta } from "/var/www/2025-07-03_16_54/pages/order/manage.vue?macro=true";
import { default as registrationoH_OLCSa_45PkcyoF4mthpzvTwt7smfYVrxhyaR_45ClP1gMeta } from "/var/www/2025-07-03_16_54/pages/registration.vue?macro=true";
import { default as run_45schedulefAJlfOnRUjGHZKQpWRZQ8BEC_45aKB_4577oUSyRAkuxkycMeta } from "/var/www/2025-07-03_16_54/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyjmwLdT8ufbLfs29xPB2hRrfMQofkUr8kzm4e_45BlEXaAMeta } from "/var/www/2025-07-03_16_54/pages/safe-custody.vue?macro=true";
import { default as imagemod5C2eXuKCn6IaKXqD_45v6efj5l5XrIAaeXoLKmyxOcMeta } from "/var/www/2025-07-03_16_54/pages/ui-kit/image.vue?macro=true";
import { default as indexOfcNwIULaN2iFWFhI_t1aeS2CfZWq6Wp3noUBQ0oltQMeta } from "/var/www/2025-07-03_16_54/pages/ui-kit/index.vue?macro=true";
import { default as bagHViGyzMHBZZmooTPWH4AakSXjLmT0YdJe6WWjfk8WUAMeta } from "/var/www/2025-07-03_16_54/pages/wrapping/bag.vue?macro=true";
import { default as boxzcSq8c9Kkyb_452RzqrhyhWhgsJ9l7_waPA9oUeD6cvB8Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingOe3qadDVCrvWyIWH7qydf8Pb4p62CcgfVGxVSG8YdYgMeta } from "/var/www/2025-07-03_16_54/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayWy4xq5NrvafkeLnHWp0DBhAzWhrx3ntpH49q0NV1wwkMeta } from "/var/www/2025-07-03_16_54/pages/happybirthday.vue?macro=true";
import { default as managei1vf_45neWo_45Vkd1f_45uxeaG_45pTbWmgi_8K4M_A4IRZ0mEMeta } from "/var/www/2025-07-03_16_54/pages/iframe/manage.vue?macro=true";
import { default as authTE0EVBJ3e7FOFkRQCdJ6W9OBzgKYPLyHSa8KJ_45RaiTgMeta } from "/var/www/2025-07-03_16_54/pages/personal/auth.vue?macro=true";
import { default as publicRlm_5Je0xDXkrhAYIhWh7czw_453FY43usuqoR6TkF7_45oMeta } from "/var/www/2025-07-03_16_54/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerNSoiQmNqQShAHLoSEPlUKx5WtPaZmZFD5zeYqfUkoVoMeta } from "/var/www/2025-07-03_16_54/pages/already-answer.vue?macro=true";
import { default as tariffsm9Z9l_45pWsmr6s_egSMWdmsm5dhlJg534ZQoh0miRaY0Meta } from "/var/www/2025-07-03_16_54/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93qga7_CqUkZHorimJ1BVYQk13H_45WoEgJh72IY6dBv7mEMeta } from "/var/www/2025-07-03_16_54/pages/order/pay/[id].vue?macro=true";
import { default as indexfsyRCLSX1ipZuCjCbCH6fI3MrIaTPx35t2piQwiDKuMMeta } from "/var/www/2025-07-03_16_54/pages/personal/index.vue?macro=true";
import { default as privacy_45policy1bFNrJ2Ssnzsb64My5FRC9dJNxGVREll2zardqKoclgMeta } from "/var/www/2025-07-03_16_54/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93gn_1rfDcvQc7wqaF18agaxtTTwa2uD7pXKXvzvvHji4Meta } from "/var/www/2025-07-03_16_54/pages/welcome/[hash].vue?macro=true";
import { default as index9_45B4_MZ8T_uWE38LW7AfMBs7lNSdNC5PE0khbaLklxMMeta } from "/var/www/2025-07-03_16_54/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiafcqOGH2v41rxRqz7owiqppwPTxCfahqp1XznzzhuXagMeta } from "/var/www/2025-07-03_16_54/pages/delivery-russia.vue?macro=true";
import { default as payment_45methods8eib_x9JBUSVGNpVFrb5kzHbd9kYxiHLDBwSDN8e93wMeta } from "/var/www/2025-07-03_16_54/pages/payment-methods.vue?macro=true";
import { default as qr_45infoODlgaGvao1oXDsriADMe2PU0U17YJbxXbFOOFFiM_EsMeta } from "/var/www/2025-07-03_16_54/pages/payment/qr-info.vue?macro=true";
import { default as successi7Pb8JZ6_45YJ7auOet6_Jl9lYYL3oxJZMT_wvY4CNzecMeta } from "/var/www/2025-07-03_16_54/pages/payment/success.vue?macro=true";
import { default as importBtVxkDex1_zftcKyAqrJsbvLhJP4kSVOuWwokVFKLoIMeta } from "/var/www/2025-07-03_16_54/pages/personal/import.vue?macro=true";
import { default as logoutmjbH8GHMJ04m70_d6OQPpCsjewyduKrDaqLH80ewsOcMeta } from "/var/www/2025-07-03_16_54/pages/personal/logout.vue?macro=true";
import { default as address_45delivery0LjZXlm8SkfXlLuzhkcOnMuGOUHRJ_452mJvtdHpj8ObwMeta } from "/var/www/2025-07-03_16_54/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryFg4Xq0RN5Qwgv_CurjpdkxNqGVLvTvNRO9oXQ3rd1VMMeta } from "/var/www/2025-07-03_16_54/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20243_45k_45sTgM8ocTLso2ceLzDQ0MsNCwLx3MgROqFbnbYLYMeta } from "/var/www/2025-07-03_16_54/pages/happynewyear2024.vue?macro=true";
import { default as ozonbkf54SwdRzcf8eTiek4h2Ghadm57bCC1spAAcVJk288Meta } from "/var/www/2025-07-03_16_54/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failqsolpHoMf1qpas_2iZxZcG61g1OmDugDJHUiQTGeyigMeta } from "/var/www/2025-07-03_16_54/pages/payment/pay-fail.vue?macro=true";
import { default as accountiwgXmiJR5F5MZgoPveOnTIuZGcZfyc9Wmvt7ff6xNJsMeta } from "/var/www/2025-07-03_16_54/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsrS0Ct_45AyA44zqCbW0bKBKYwkqUbD0L5wffmNT8ZJpWgMeta } from "/var/www/2025-07-03_16_54/pages/prohibited-goods.vue?macro=true";
import { default as directionTIkDQZ_45m7NkHwc4gaNCy4h_fkCqZXuVcXqRxBU1eIU0Meta } from "/var/www/2025-07-03_16_54/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupH1Y3Oz7WZaIo6cT9GcqVUP6LnIuZe_45Y36cR2ngXEpeIMeta } from "/var/www/2025-07-03_16_54/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoGUO8cTpL5VNygvCcxs9uXt0_45oC3t_45OaXdGzqvhSysywMeta } from "/var/www/2025-07-03_16_54/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorafZHtLz813RDl3gnSPVgr0WbIn29NxxZZO5zjbbV8s4Meta } from "/var/www/2025-07-03_16_54/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesFdOE18hAaN5IDXfnUzHuENBuEODOm6Onw_kKYQ81j8QMeta } from "/var/www/2025-07-03_16_54/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_931uBgWBX1Ea2WciK2bM_45QHegHPnsLiEVOHF_aNNL1WAUMeta } from "/var/www/2025-07-03_16_54/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45info0F_aEuHhbaIDpHL2m0EJj75VjJb4F1tdBZIb8F_45HDt0Meta } from "/var/www/2025-07-03_16_54/pages/payment/card-info.vue?macro=true";
import { default as discountavS4gGVQ79wGMoj8wHKNTLgD1xgmuSqyOhSlY1WqimMMeta } from "/var/www/2025-07-03_16_54/pages/personal/discount.vue?macro=true";
import { default as hard_45boxgXwwN_hbhaCdtQFyHyN_45xhWLFCD4n7heJGQxwzvvK_0Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptppIrsmKH8oIaUQqdETD_5N2qSRiNxl0_9MYtWADMNGYMeta } from "/var/www/2025-07-03_16_54/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917O5SUeRtKt6oBQRlbCj3fkJ0D30gcWYoOW7KREVnJG20Meta } from "/var/www/2025-07-03_16_54/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45application1uSFFgXijvdbGmEpuA1udqoWbiyOUMwjs7Uz5wTJIMUMeta } from "/var/www/2025-07-03_16_54/pages/mobile-application.vue?macro=true";
import { default as indexeHa5wu688Mp_45FVkf67U8AyjDszd_457LM96nXpel1uqC0Meta } from "/var/www/2025-07-03_16_54/pages/order/create/index.vue?macro=true";
import { default as boat5CS4mu7SnZ6UMvXCA7LqVpCFD2XO10QsQ5y677IH9nQMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaFf7rzcL82lVo4mWBQsiBSWXUK0Yp8gItcR9_IX_VAYsMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardXHhd7ls_457hHKg8awLxQcj5d9tWlaTqV96kBNg3HO3nMMeta } from "/var/www/2025-07-03_16_54/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesZY9otSzUPMnlZIDWTqnuo9VFMfFc4JeQ2e3QIR8obQYMeta } from "/var/www/2025-07-03_16_54/pages/personal/promocodes.vue?macro=true";
import { default as bench8pHrVHtktwbjKBaexTpmGU0IaQ4H3Q6nOOxe0uYUTi8Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/bench.vue?macro=true";
import { default as booksWLWSNz3xL_453vNNuLLjePZZEfroQQU4s8PyZ2dkZsQPcMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/books.vue?macro=true";
import { default as cableiYvbJo6hbgiujdGj2c5zJwiV3QO3kpj2sJ5pQpCSkzYMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/cable.vue?macro=true";
import { default as chairePVt86zLDujrFDio01hgWi2KjNXV3wf20ahu_2unLyYMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsyHWRy5xNB_45rPmPIL0eU04myklseHdJUqHWRFMkzXUNoMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/goods.vue?macro=true";
import { default as indexQVFDYb_45PhP5TVI7bJr_45nENtGUzzgh8u_WtWlao3HGpgMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/index.vue?macro=true";
import { default as metalknpF3eUE9GnH2XJ6Q2FhQGm_45PmydVVhcaCvewOcpJz8Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoh3wq_ipeVYyarhkInmQgoH60ccTciqFuG4Ttw49iR3MMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesIDAmQ0cqvfv5I8C8HuvNCIEDKuJWqHjL_45x2KWarvlCMMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsagz6n6JRiJmhfTT659qLI2YzQDiJgnSer19gGpd3jowMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxFwQzXV7jqUsejvjGtFdKrqA_45M0aikRsTcIe7w5NJqP0Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93QhoNFFgCZVHyAvlwEWyHSHA5B_KSrTvz_N7PgigpQCQMeta } from "/var/www/2025-07-03_16_54/pages/personal/bonus/[tab].vue?macro=true";
import { default as print07Bx5yBiO_CcwF4j_Wj_qaRk895qpvKS7bvAatgAAg8Meta } from "/var/www/2025-07-03_16_54/pages/personal/order/print.vue?macro=true";
import { default as dishesEkaf4wZwqsa2jHdbyx3R8z0V8nUnR43mD4P9znm7eu0Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginefxoMu0dKiHWZupGb8BKgkedPtG34DTPIBBaSdkJH8NYMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberP8JLXkJwa_45C_sZHLS2IFLGLj4ioYjdBpsf_456AnVQ3DUMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsw0GkFLoz7L5puU1pGoiD_45J48O_PvT3FvF3Cncfv0tVgMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmjFP9s6fFbbuRyw1VfedDi7iBk0IQNsQzl9QH3N0PP48Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingPkr2mzXmQwwegccAJRKBvdAYkSGTosr1Sm2JV6Pe_45E0Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capital_45Jpta2aA540uXZ2fKCciqKaBin2i0B5do0ITcxj6XZ4Meta } from "/var/www/2025-07-03_16_54/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93UVOH_4XKNMIemzysqeXAb0WoNf5Hm5ESh8oI5cP065oMeta } from "/var/www/2025-07-03_16_54/pages/personal/order/[guid].vue?macro=true";
import { default as createTwRgcSQk2WXdmsBd8FYCU7kOjm_45y0TuMYUwySIK4QV0Meta } from "/var/www/2025-07-03_16_54/pages/personal/order/create.vue?macro=true";
import { default as barrels_45Pr9KGKhwb8kqfDepxfKhDO5qeJCrQahqLdxzvwsVUUMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesfjbMAeCP2JlNgD1S3ZPu8M57MdhwuyQeetpvMOan9sYMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileEwpDFC8bE_45azGMdcaZjHbg58YjG1dmCVhvLhE4m61mIMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailer7ksriz71rPlusXW_v1nrlSczmlDvm5WexAezNQyxg48Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagefZZi6UwNH_45vzSUNeBrhmOZMUl0Ipy0zSTc2q2fbSZT0Meta } from "/var/www/2025-07-03_16_54/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successsIuyQvjfxasELMnHNspRiqUI_fp5UrAQtBtZXzn2l_0Meta } from "/var/www/2025-07-03_16_54/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagedK9ePHFsg0ExqidS6Hf7EkQg3VNLDbB3k2plaOCbLsQMeta } from "/var/www/2025-07-03_16_54/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberries7NP0Ujm6zwQpLd4pgyCafEzNZW082ainmQbdwz3Kzj4Meta } from "/var/www/2025-07-03_16_54/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93hDE_454t75KBl0bxBAffkSKZT_45a3rRuLktX8V53byFcW4Meta } from "/var/www/2025-07-03_16_54/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureoE3MYOE7J_45TK3o9bXDyn5oChHi8KR35pEdFwqTDu3C8Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized7XcSB13_45LprkuZvPcReh9G_45GaR2SMiQ8iqyLWhXcYwIMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeBh_xtTBE2r3l_45Bdav4bOOE5GIwS0hmjgvquip9GouQQMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93pFKlarR9vo1ewXMxH0k2sPj7U8bhiQeZCPzfm765F5cMeta } from "/var/www/2025-07-03_16_54/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93ESvc_45fYQXqx2NHOpSEq3RNkh_koixO1kwX5cgahNlwUMeta } from "/var/www/2025-07-03_16_54/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsPNgHUCjXx0yA9KjIZqkxyics7ftz92d1aTGZDWZIjgIMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspaperspAgkWqTvszLxeZDsFYKZP37S_45BCBnEbJMwmq3NxC9WAMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoQ7i3GieToYRPsTKD_C0RINHuFvH68ClefsNVnt7XLxkMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileriSAiXqcL0uVZ66xR_EiMqDY2DeyS_45elswZr_dzFca0Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexDZTF0ubWNxbxcnDfBMsvnCCtBjlWleALlTTnuYvpkTwMeta } from "/var/www/2025-07-03_16_54/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketI1S8C80Xl4KK038PmFYXjriSKZ_45BvCRuJtDGzpPzZFwMeta } from "/var/www/2025-07-03_16_54/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesepFp_38kI6BytW1IZUz1Ocf4KYp2J_TolBPm1cWEl_wMeta } from "/var/www/2025-07-03_16_54/pages/personal/orders/templates.vue?macro=true";
import { default as indexH8_whs58_7_SZwMTUHCjz0GV03ZigTyh4Yqu_B7LcCEMeta } from "/var/www/2025-07-03_16_54/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorkLmSIYqGJACEx5a39Yeim_FRRv_455vXUvlPpc0z1jm_45gMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93M4Fl6UTTxpwJYCEP6mKqJCyCcGQDCL9SgZltlSPW0JEMeta } from "/var/www/2025-07-03_16_54/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexQbMRs0yHqu0aqIU6qUEDME9fdqlIBUWmCNEOwqWqVisMeta } from "/var/www/2025-07-03_16_54/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93oOfl9s_sy9hVM7hGSJ4cwNW1oSQbjeBzQNfZ0DqpHrEMeta } from "/var/www/2025-07-03_16_54/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsIHiT2cBmVN6iNT9kE9sa_yh1EaHb0kZweqB1sp66IlAMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexYE_cUznDTfHOoe6liCr_45w3BPsUr0otVukAoJrCtaDfEMeta } from "/var/www/2025-07-03_16_54/pages/personal/group-printing/index.vue?macro=true";
import { default as indexa2Z7VQ2vtADVfcTiIVJ_45ZxqasNTDOfjFhCum9m36DnIMeta } from "/var/www/2025-07-03_16_54/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devices3_45gfrKyj3fwAV7Gp_TA8EcZKHaVSaUkus6qpfkDiSvcMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93JktCn89woCSu_457HzPM_D7pzTLwlzw5kUNDPuGJiI1XsMeta } from "/var/www/2025-07-03_16_54/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_938iLJoU75vxD8pGD0H8Ou303iE2_DftsNo5TGlQFb8SoMeta } from "/var/www/2025-07-03_16_54/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93w2_jCq1nmv_45SNgjvnouxy3zsMmoDGpG2nYxDLPHB0y0Meta } from "/var/www/2025-07-03_16_54/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentqzJ3UZHUdqPEf3zEGbzEthqSP09N4upIBHE5XytohU0Meta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsy61OZtTnYxHPBro6pKrGl4KN0M18E_45cdxsbgueQLQvcMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentstX2iYjOjfvhFMXpIe3A5xHcnZ6elqevdYzTIoFEeasgMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentEbOw76LzPoKR1hYM6FeUAoVN8uaC9hLYKVWLgtLLpZcMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationqJkIsI64a5dBGf_3293CBbLlYEYvmluGjQhFPFQ9kisMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93YiQkBCcpXuJnAHnThv9z7amA2OwEiukURA5Qjb2hEP0Meta } from "/var/www/2025-07-03_16_54/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationXrc6pJ8V5qG3GHWi4UDyGra7y6_452zK_i8GEf8Bmv57MMeta } from "/var/www/2025-07-03_16_54/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-07-03_16_54/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-07-03_16_54/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-07-03_16_54/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-07-03_16_54/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93BdZjPfihbQnuz3vYIOtAwp7dICxmOzxoaaRnMjrj_v4Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-07-03_16_54/pages/cookie.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-07-03_16_54/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-07-03_16_54/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-07-03_16_54/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-07-03_16_54/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurszXbIcJ6_45F_45uyaTM94_2tRokVh0n0HP6aHGMhFfSjDqcMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-07-03_16_54/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-07-03_16_54/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-07-03_16_54/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contacts8_45TzRToe6U7yRusvNYYvat1nXQIrQCSAtZpCNL_Ss_45MMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-07-03_16_54/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-07-03_16_54/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-07-03_16_54/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-07-03_16_54/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-07-03_16_54/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-07-03_16_54/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-07-03_16_54/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-07-03_16_54/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemex0AFP_tZ8gg3kNGMU_452E_F7M00GuISNYn_AlGvlP0_QMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93wJ69KPLqgjeWmma0jp5VKUNzosmyPwt9cIw0qimojs8Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-07-03_16_54/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-07-03_16_54/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-07-03_16_54/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-07-03_16_54/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-07-03_16_54/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-07-03_16_54/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexyRXAtARUjB4WeZG_45E9Qb8e7t6oD1Y8F1cJRDRVfv3LgMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-07-03_16_54/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-07-03_16_54/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructor2f5Ro8_uyGS6Q5YLpPCOvQTtXBEfCuhCFc7873vlMfIMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexhTRWGxZZhSilGY9b89pstWTF6bKUOlBnetPEz_45tb8uIMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-07-03_16_54/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-07-03_16_54/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93TzeQDBZzehHepONsBGRH78Qfy7N2DXZVDBD13gBbX1EMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-07-03_16_54/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-07-03_16_54/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-07-03_16_54/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-07-03_16_54/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-07-03_16_54/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-07-03_16_54/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-07-03_16_54/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-07-03_16_54/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-07-03_16_54/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayWy4xq5NrvafkeLnHWp0DBhAzWhrx3ntpH49q0NV1wwkMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: managei1vf_45neWo_45Vkd1f_45uxeaG_45pTbWmgi_8K4M_A4IRZ0mEMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-07-03_16_54/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-07-03_16_54/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsm9Z9l_45pWsmr6s_egSMWdmsm5dhlJg534ZQoh0miRaY0Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexfsyRCLSX1ipZuCjCbCH6fI3MrIaTPx35t2piQwiDKuMMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-07-03_16_54/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-07-03_16_54/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-07-03_16_54/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importBtVxkDex1_zftcKyAqrJsbvLhJP4kSVOuWwokVFKLoIMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutmjbH8GHMJ04m70_d6OQPpCsjewyduKrDaqLH80ewsOcMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-07-03_16_54/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-07-03_16_54/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20243_45k_45sTgM8ocTLso2ceLzDQ0MsNCwLx3MgROqFbnbYLYMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonbkf54SwdRzcf8eTiek4h2Ghadm57bCC1spAAcVJk288Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountiwgXmiJR5F5MZgoPveOnTIuZGcZfyc9Wmvt7ff6xNJsMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-07-03_16_54/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-07-03_16_54/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-07-03_16_54/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-07-03_16_54/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorafZHtLz813RDl3gnSPVgr0WbIn29NxxZZO5zjbbV8s4Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-07-03_16_54/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountavS4gGVQ79wGMoj8wHKNTLgD1xgmuSqyOhSlY1WqimMMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-07-03_16_54/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917O5SUeRtKt6oBQRlbCj3fkJ0D30gcWYoOW7KREVnJG20Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-07-03_16_54/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexeHa5wu688Mp_45FVkf67U8AyjDszd_457LM96nXpel1uqC0Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesZY9otSzUPMnlZIDWTqnuo9VFMfFc4JeQ2e3QIR8obQYMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93QhoNFFgCZVHyAvlwEWyHSHA5B_KSrTvz_N7PgigpQCQMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: print07Bx5yBiO_CcwF4j_Wj_qaRk895qpvKS7bvAatgAAg8Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-07-03_16_54/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93UVOH_4XKNMIemzysqeXAb0WoNf5Hm5ESh8oI5cP065oMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createTwRgcSQk2WXdmsBd8FYCU7kOjm_45y0TuMYUwySIK4QV0Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-07-03_16_54/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-07-03_16_54/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberries7NP0Ujm6zwQpLd4pgyCafEzNZW082ainmQbdwz3Kzj4Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93ESvc_45fYQXqx2NHOpSEq3RNkh_koixO1kwX5cgahNlwUMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexDZTF0ubWNxbxcnDfBMsvnCCtBjlWleALlTTnuYvpkTwMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketI1S8C80Xl4KK038PmFYXjriSKZ_45BvCRuJtDGzpPzZFwMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesepFp_38kI6BytW1IZUz1Ocf4KYp2J_TolBPm1cWEl_wMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexH8_whs58_7_SZwMTUHCjz0GV03ZigTyh4Yqu_B7LcCEMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93M4Fl6UTTxpwJYCEP6mKqJCyCcGQDCL9SgZltlSPW0JEMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexQbMRs0yHqu0aqIU6qUEDME9fdqlIBUWmCNEOwqWqVisMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93oOfl9s_sy9hVM7hGSJ4cwNW1oSQbjeBzQNfZ0DqpHrEMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexYE_cUznDTfHOoe6liCr_45w3BPsUr0otVukAoJrCtaDfEMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexa2Z7VQ2vtADVfcTiIVJ_45ZxqasNTDOfjFhCum9m36DnIMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93JktCn89woCSu_457HzPM_D7pzTLwlzw5kUNDPuGJiI1XsMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_938iLJoU75vxD8pGD0H8Ou303iE2_DftsNo5TGlQFb8SoMeta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93w2_jCq1nmv_45SNgjvnouxy3zsMmoDGpG2nYxDLPHB0y0Meta || {},
    component: () => import("/var/www/2025-07-03_16_54/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-07-03_16_54/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-07-03_16_54/pages/shippingtypes/personalitemstransportation.vue")
  }
]